import { render, staticRenderFns } from "./sheBao.vue?vue&type=template&id=44d2b452&scoped=true&"
import script from "./sheBao.vue?vue&type=script&lang=js&"
export * from "./sheBao.vue?vue&type=script&lang=js&"
import style0 from "./sheBao.vue?vue&type=style&index=0&id=44d2b452&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2b452",
  null
  
)

export default component.exports